module.exports = __webpack_public_path__ + "img/编组(21).f78fccdb.png";